import Vault from './Vault';

export default Vault;